import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./DropdownFilterMenu.module.scss";
import {useDropdownFilterMenuLogic} from "./DropdownFilterMenu.logic";
import {FontIcon, Icon} from "../../../components/common/FontIcon";

export interface IDropdownFilterMenuProps {
  label: string;
  icon?: Icon;
  onClickMenuToggleHandler: () => void;
  isActive?: boolean;
  component: VoidFunctionComponent;
}

export const DropdownFilterMenu = React.forwardRef<HTMLDivElement, IDropdownFilterMenuProps>(({label, icon, isActive, onClickMenuToggleHandler, component: Component}, ref) => {
  const {useContainerClassName} = useDropdownFilterMenuLogic({
    isActive: !!isActive,
    containerClassName: s.dropdownContainer,
    whenActiveContainerClassName: s.active,
  });
  return (
    <div className={useContainerClassName} ref={ref}>
      <button
        className={s.toggleButton}
        onClick={onClickMenuToggleHandler}
      >
        <span className={s.buttonLabel}>{label}</span>
        <FontIcon icon={icon ?? "icon-angle-down"}/>
      </button>
      {/* may need extra custom handling for when partially outside of screen */}
      <div className={s.dropdownMenu}>
        <Component />
      </div>
    </div>
  );
});

